import { axiosPostHandler } from './config';
import getEncrypt from '_lib/encrypt/dsk.js';

// web上报104
export function reportDataWeb(params) {
  var url = '/account/data_report_web/';

  const time_ = ~~(+new Date().getTime() / 1000);
  return axiosPostHandler(
    url,
    {
      type: 104,
      time_,
    },
    getEncrypt(
      {
        events: [
          {
            time: String(time_),
            ...params,
          },
        ],
      },
      true,
    ),
  );
}
